const smallDesktopBreakpoint = 900;

export default `
.ds-header__logo--short {
  display: none;
}

@media only screen and (max-width: ${smallDesktopBreakpoint - 1}px) {
  .ds-header__logo {
    display: none;
  }
  .ds-header__logo.ds-header__logo--short {
    display: block;
  }
}
`;
